import styled from "styled-components"

export const WysiwygStyles = styled.div`
	margin: 4px 0px 4px 0px;
`
